/* eslint-disable prefer-template, newline-before-return, react/jsx-closing-bracket-location, implicit-arrow-linebreak, brace-style */
import Layout from "../../../components/Layout";
import useStyles from "../styles";
import useValidator from "../../../hooks/useValidator";
import Button from "../../../components/Button";
import PageTitle from "../../../components/PageTitle";
import BreadCrumb from "../../../components/BreadCrumb";
import { useState, useEffect } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import { Icon } from "@iconify/react";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Modal from "../../../components/Modal";
import { Grid, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Badge from "../../../components/Badge";
import { httprequest } from "../../../data/api";
import { useParams, useSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import WidgetTitle from "../../dashboard/components/WidgetTitle/WidgetTitle";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import AssignmentDetailText from "../../assignment/components/AssignmentDetailText";
import useWindowSize from "../../../hooks/useWindow";
import { saveAs } from "file-saver";
import HTMLDocx from "html-docx-js/dist/html-docx";
import RightDrawer from "../../../components/RightDrawer";
import NotFounditem from "../../error/NotFound";
import noexam from "../../../assets/images/noexam.svg";
import { useUserState } from "../../../context/UserContext";
import GenerateQuestionsDrawer from "../../lessonnote/component/GenerateQuestionsDrawer";
import { questionDisplayIndex } from "../../../utils/questionDisplayIndex";

const ASSIGNMENT_CONFIG_ENDPOINT = "/api/v1/assignment-configs";
const ASSIGNMENT_ENDPOINT = "/api/v1/assignment";
// const SUBMISSION_ENDPOINT = "/api/v1/submission";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const questionTypeOptions = [
  { value: "multiple_choice", text: "Multiple Choice" },
  { value: "true_false", text: "True / False" },
  { value: "checkbox", text: "Checkbox" }
];

// ─── Shared question builder modal content ───────────────────────────────────
function AssignmentQuestionsModalContent(props) {
  const {
    questionArr,
    classes,
    questionsValidator,
    isSubmitting,
    onQueChange,
    onQueTypeChange,
    onQuePointChange,
    onCorrectChoiceChange,
    onMultipleChoiceChange,
    onAdditionalOptions,
    onAdditionalQuestion,
    onRemoveQuestion,
    onRemoveChoice,
    onQueDescChange,
    onMenuClick,
    onMenuClose,
    onToggleDescription,
    onRemoveDescription,
    onAddToBankChange,
    onQueImageChange,
    onOptionImageChange,
    onRemoveQueImage,
    onRemoveOptionImage,
    onIconClick,
    onIconOptionClick,
    anchorEl,
    menuOpen,
    idPrefix = "q",
    showDraftAndCreateButtons = false,
    hideAddQuestionAction = false,
    onSave,
    onSaveDraft,
    isDraftSubmitting,
    saveButtonLabel = "Save Changes",
    editFooterMode = null,
    onEditUpdate,
    onEditPublish,
    onEditWithdraw,
    isEditUpdating = false,
    isEditPublishing = false,
    isEditWithdrawing = false
  } = props;

  return (
    <>
      <div className="margin-top">
        <Grid container spacing={2}>
          {questionArr?.map((que, queInd) => (
            <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
              <div className={classes.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.quesaction}>
                      <label className={classes.quelabel}>Enter Question {queInd + 1}</label>
                      {questionArr?.length > 1 ? (
                        <Icon icon="material-symbols:delete-outline" width="20" height="20" className="delete-icon" onClick={() => onRemoveQuestion(queInd)} />
                      ) : null}
                    </div>
                    <div className={classes.textandimgmain}>
                      <div className={classes.textandimg}>
                        <input
                          type="text"
                          placeholder="Type Question"
                          name="question"
                          value={que?.question ?? ""}
                          onChange={(e) => onQueChange(e, queInd)}
                        />
                        {questionsValidator.message(`q_text_${queInd}`, (que?.question ?? "").trim(), "required")}
                        <div onClick={() => onIconClick?.(queInd, idPrefix)} className={classes.queimg}>
                          <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            id={`${idPrefix}-imageInput-${queInd}`}
                            onChange={(e) => onQueImageChange?.(e, queInd)}
                            style={{ display: "none" }}
                          />
                        </div>
                        {que?.file?.file_url ? (
                          <div className={classes.preiewcont}>
                            <img src={que.file.file_url} alt="" />
                            <Icon icon="material-symbols:delete-outline" width="20" height="20" className="delete-icon" onClick={() => onRemoveQueImage?.(queInd, que.file.upload_id)} />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup label="Add Answer Type" required children={
                      <select name="type" value={que?.type ?? ""} onChange={(e) => onQueTypeChange(e, queInd)}>
                        <option value="">--- Select ---</option>
                        {questionTypeOptions?.map((label) => (
                          <option key={label?.value} value={label?.value}>{label?.text}</option>
                        ))}
                      </select>
                    } />
                    {questionsValidator.message(`q_type_${queInd}`, que?.type, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      className={classes.pointsInput}
                      label="Question Point"
                      inputType="number"
                      inputName="grade_point"
                      placeHolder="Enter Question Points"
                      value={que?.grade_point ?? ""}
                      onChange={(e) => onQuePointChange(e, queInd)}
                    />
                    {questionsValidator.message(`q_points_${queInd}`, que?.grade_point != null && String(que.grade_point).trim() !== "" ? que.grade_point : null, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {"description" in que && que?.description != null ? (
                      <div className="margin-top full-width">
                        <div className="flex gap-10 justify-items-space">
                          <label className={classes.enterque}>Question Description</label>
                          <div className="delete-icon" onClick={() => onRemoveDescription(queInd)}>
                            <Icon icon="ooui:close" width="20" height="20" />
                          </div>
                        </div>
                        <div className={classes.textandimgmain}>
                          <input type="text" placeholder="Enter Description" name="description" value={que?.description ?? ""} onChange={(e) => onQueDescChange(e, queInd)} />
                        </div>
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    {(que?.options || []).map((opt, i) => (
                      <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                        <div>
                          <div className="flex gap-10 justify-items-space">
                            <label className={classes.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                            {que?.options?.length > 1 && que?.type !== "true_false" ? (
                              <Icon onClick={() => onRemoveChoice(i, queInd)} className="delete-icon" icon="ooui:close" width="20" height="20" />
                            ) : null}
                          </div>
                          <div className={classes.textandimgmain}>
                            <div className={classes.textandimg}>
                              <input
                                type="text"
                                placeholder="Enter option"
                                value={typeof opt === "object" ? (opt?.text ?? opt?.file_url ?? "") : (opt ?? "")}
                                onChange={(e) => onMultipleChoiceChange(e, i, queInd)}
                                disabled={que?.type === "true_false"}
                              />
                              {que?.type !== "true_false" && (
                                <div onClick={() => onIconOptionClick?.(i, queInd, idPrefix)} className={classes.queimg}>
                                  <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                  <input
                                    type="file"
                                    accept=".jpg, .jpeg, .png"
                                    id={`${idPrefix}-imageInput-${i}${queInd}`}
                                    onChange={(e) => onOptionImageChange?.(e, i, queInd)}
                                    style={{ display: "none" }}
                                  />
                                </div>
                              )}
                              {typeof opt === "object" && opt?.file_url ? (
                                <div className={classes.preiewcont}>
                                  <img src={opt.file_url} alt="" />
                                  <Icon icon="material-symbols:delete-outline" width="20" height="20" className="delete-icon" onClick={() => onRemoveOptionImage?.(i, queInd, opt.upload_id)} />
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="text-align-left" style={{ marginTop: 5 }}>
                            <div className={classes.correctcontainer}>
                              <input
                                type={que?.type === "checkbox" ? "checkbox" : "radio"}
                                name={que?.type === "multiple_choice" || que?.type === "true_false" ? `answer-${queInd}` : "answer"}
                                value={i}
                                checked={que?.type === "checkbox" ? (que?.answer || []).includes(i) : (que?.answer || [])[0] === i}
                                onChange={(e) => onCorrectChoiceChange(e, i, queInd)}
                              />
                              <label className={classes.correctlabel}>is correct</label>
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                )}

                {(que?.type === "multiple_choice" || que?.type === "checkbox") && (
                  <div style={{ marginTop: 4 }}>
                    {questionsValidator.message(`q_answer_${queInd}`, (que?.answer?.length > 0) ? que.answer : null, "required")}
                  </div>
                )}

                {(que?.type === "multiple_choice") && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another option</p>
                  </div>
                )}
                {que?.type === "checkbox" && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another checkbox</p>
                  </div>
                )}

                <div className={classes.questionfooter}>
                  <div className="flex align-items-center gap-10">
                    <input
                      type="checkbox"
                      id={`${idPrefix}_add_to_bank_${queInd}`}
                      checked={!!que?.add_to_bank}
                      onChange={(e) => onAddToBankChange(e, queInd)}
                    />
                    <label htmlFor={`${idPrefix}_add_to_bank_${queInd}`} style={{ cursor: "pointer" }}>Add to Question Bank</label>
                  </div>
                  {!que?.description && (
                    <IconButton aria-label="more" onClick={(e) => onMenuClick(e, queInd)}>
                      <Icon icon="radix-icons:dots-vertical" width="20" height="20" />
                      <label className={classes.enterque}>More</label>
                    </IconButton>
                  )}
                </div>
                <Menu anchorEl={anchorEl} open={menuOpen} onClose={onMenuClose}>
                  <MenuItem onClick={onToggleDescription}>Add Description on Question</MenuItem>
                </Menu>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>

      {!hideAddQuestionAction && (
        <div className={classes.addque}>
          <Icon icon="octicon:feed-plus-16" width="16" height="16" />
          <p onClick={onAdditionalQuestion}>Add question</p>
        </div>
      )}

      <div className={classes.btnwrapper}>
        {editFooterMode === "published" ? (
          <Button
            variant="primary"
            color="btndefault"
            buttonSize="fluid"
            buttonName="Withdraw"
            isLoading={isEditWithdrawing}
            onClick={() => onEditWithdraw && onEditWithdraw()}
          />
        ) : editFooterMode === "draft" || editFooterMode === "withdrawn" ? (
          <>
            <Button
              variant="primaryoutline"
              color="btnfontprimary"
              buttonSize="fluid"
              buttonName="Update"
              isLoading={isEditUpdating}
              onClick={() => onEditUpdate && onEditUpdate()}
            />
            <Button
              variant="primary"
              color="btndefault"
              buttonSize="fluid"
              buttonName="Publish questions"
              isLoading={isEditPublishing}
              onClick={() => onEditPublish && onEditPublish()}
            />
          </>
        ) : showDraftAndCreateButtons ? (
          <>
            <Button
              variant="primaryoutline"
              color="btnfontprimary"
              buttonSize="fluid"
              buttonName="Save as draft"
              isLoading={isDraftSubmitting}
              onClick={() => onSaveDraft && onSaveDraft()}
            />
            <Button
              variant="primary"
              color="btndefault"
              buttonSize="fluid"
              buttonName="Publish"
              isLoading={isSubmitting}
              onClick={() => onSave && onSave()}
            />
          </>
        ) : (
          <Button
            variant="primary"
            color="btndefault"
            buttonSize="fluid"
            buttonName={saveButtonLabel}
            isLoading={isSubmitting}
            onClick={() => onSave && onSave()}
          />
        )}
      </div>
    </>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────
const AssignmentDetail = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { userRole } = useUserState();
  const width = useWindowSize();
  const mobile = width < 600;
  const isTeacher = userRole?.role_type === "employee";
  const isAdmin = userRole?.role_type === "school_admin";

  // ── data state
  const [assignmentData, setAssignmentData] = useState({});
  const [assignmentAttendees, setAssignmentAttendees] = useState([]);
  const [attendeeFilter, setAttendeeFilter] = useState([]);

  // ── tab / modal / drawer state
  const [value, setValue] = useState("1");
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isGenerateDrawerOpen, setIsGenerateDrawerOpen] = useState(false);
  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isEditQuestionsModalOpen, setIsEditQuestionsModalOpen] = useState(false);
  const [isMetadataDrawerOpen, setIsMetadataDrawerOpen] = useState(false);

  // ── question arrays
  const [addQuestionArr, setAddQuestionArr] = useState([]);
  const [editQuestionArr, setEditQuestionArr] = useState([]);

  // ── loading flags
  const [isAddingQuestions, setIsAddingQuestions] = useState(false);
  const [isAddingDraft, setIsAddingDraft] = useState(false);
  const [isUpdatingQuestions, setIsUpdatingQuestions] = useState(false);
  const [isPublishingEditQuestions, setIsPublishingEditQuestions] = useState(false);
  const [isWithdrawingEditQuestions, setIsWithdrawingEditQuestions] = useState(false);
  const [isSavingConfig, setIsSavingConfig] = useState(false);

  // ── context menu anchors
  const [addAnchorEl, setAddAnchorEl] = useState(null);
  const [editAnchorEl, setEditAnchorEl] = useState(null);
  const [currentAnchor, setCurrentAnchor] = useState(null);
  const addMenuOpen = Boolean(addAnchorEl);
  const editMenuOpen = Boolean(editAnchorEl);

  // ── config (right drawer) form
  const [configForm, setConfigForm] = useState({
    title: "",
    description: "",
    instructions: "",
    submission_date: "",
    allow_late_submission: false,
    randomize_questions: false,
    randomize_options: false,
    display_score_after_due_date: true,
    questions_display_mode: "all_at_once"
  });

  // ── validators
  const [addQuestionsValidator, showAddQuestionsValidator] = useValidator();
  const [editQuestionsValidator, showEditQuestionsValidator] = useValidator();
  const [configValidator, showConfigValidator] = useValidator();

  // ── student results & submission viewer
  // const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false);
  // const [currentSubmission, setCurrentSubmission] = useState(null);
  // const [viewingStudentForModal, setViewingStudentForModal] = useState(null);
  // const [isFetchingSubmission, setIsFetchingSubmission] = useState(false);
  const [isFetchingResults, setIsFetchingResults] = useState(false);

  const hasQuestions = (assignmentData?.questions?.length ?? 0) > 0;
  const configData = assignmentData;
  const assignmentStatus = (assignmentData?.status || "").toLowerCase();
  const isPublishedAssignment = assignmentStatus === "published";
  const isWithdrawnAssignment = assignmentStatus === "withdrawn";
  const canGenerateQuestions = ["draft", "withdrawn", "empty", ""].includes(assignmentStatus);
  const editQuestionsFooterMode = isPublishedAssignment
    ? "published"
    : isWithdrawnAssignment
      ? "withdrawn"
      : "draft";

  // ─── API helpers ────────────────────────────────────────────────────────────

  const getAssignmentById = () => {
    httprequest.get(`${ASSIGNMENT_ENDPOINT}/${id}`).then((res) => {
      const raw = res?.data?.data;
      const config = raw?.config || {};
      setAssignmentData({
        ...config,
        questions: raw?.questions ?? []
      });
    }).catch((err) => {
      toast.error(err?.response?.data?.message ?? "Failed to fetch assignment.");
    });
  };

  const getAssignmentRecipients = () => {
    httprequest.get(`${ASSIGNMENT_ENDPOINT}/students/${id}`).then((res) => {
      setAssignmentAttendees(res?.data?.data);
      setAttendeeFilter(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message ?? "Failed to fetch students.");
    });
  };

  const getAssignmentResult = () => {
    setIsFetchingResults(true);
    httprequest.get(`${ASSIGNMENT_ENDPOINT}/${id}/result`).then((res) => {
      setIsFetchingResults(false);
      const data = res?.data?.data || [];
      setAssignmentAttendees(data);
      setAttendeeFilter(data);
    }).catch((err) => {
      setIsFetchingResults(false);
      toast.error(err?.response?.data?.message ?? "Failed to fetch results.");
    });
  };

  // ─── Tab & search ────────────────────────────────────────────────────────────

  const handleChange = (event, newValue) => setValue(newValue);

  const handleSearchAttendees = (e) => {
    const { value: searchVal } = e.target;
    const valArray = searchVal.split(" ");
    const result = assignmentAttendees?.filter((data) =>
      valArray?.every(
        (word) =>
          data?.student?.last_name?.toLowerCase().includes(word?.toLowerCase()) ||
          data?.student?.first_name?.toLowerCase().includes(word?.toLowerCase()) ||
          data?.status?.toLowerCase().includes(word?.toLowerCase())
      )
    );
    setAttendeeFilter(result);
  };

  // const handleViewSubmission = (submissionId, studentRow) => {
  //   setCurrentSubmission(null);
  //   setViewingStudentForModal(studentRow?.student ?? null);
  //   setIsSubmissionModalOpen(true);
  //   setIsFetchingSubmission(true);
  //   httprequest.get(`${SUBMISSION_ENDPOINT}/${submissionId}`).then((res) => {
  //     setIsFetchingSubmission(false);
  //     setCurrentSubmission(res?.data?.data ?? res?.data);
  //   }).catch((err) => {
  //     setIsFetchingSubmission(false);
  //     toast.error(err?.response?.data?.message ?? "Failed to fetch submission.");
  //   });
  // };

  // const handleCloseSubmissionModal = () => {
  //   setIsSubmissionModalOpen(false);
  //   setCurrentSubmission(null);
  //   setViewingStudentForModal(null);
  // };

  // const isAnswerCorrect = (answer, studentAnswer) => {
  //   if (!Array.isArray(answer) || !Array.isArray(studentAnswer)) return false;
  //   return JSON.stringify([...answer].sort()) === JSON.stringify([...studentAnswer].sort());
  // };

  useEffect(() => {
    if (value === "1") {
      getAssignmentById();
    } else if (value === "2") {
      getAssignmentResult();
    } else {
      getAssignmentRecipients();
    }
  }, [value]);

  // ─── Config (RightDrawer) ─────────────────────────────────────────────────

  const buildSearchWithEditConfig = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const base = params.toString();
    return base ? `?${base}&editConfig` : "?editConfig";
  };

  const handleOpenMetadataDrawer = () => {
    setConfigForm({
      title: configData?.title ?? "",
      description: configData?.description ?? "",
      instructions: configData?.instructions ?? "",
      submission_date: configData?.submission_date
        ? (typeof configData.submission_date === "string" ? configData.submission_date.substring(0, 10) : configData.submission_date)
        : "",
      allow_late_submission: configData?.allow_late_submission ?? false,
      randomize_questions: configData?.randomize_questions ?? false,
      randomize_options: configData?.randomize_options ?? false,
      display_score_after_due_date: configData?.display_score_after_due_date ?? true,
      questions_display_mode: configData?.questions_display_mode ?? "all_at_once"
    });
    setIsMetadataDrawerOpen(true);
  };

  const handleCloseMetadataDrawer = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const nextSearch = params.toString();
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : "" });
    setIsMetadataDrawerOpen(false);
  };

  useEffect(() => {
    const shouldOpen = searchParams.has("editConfig");
    if (shouldOpen && !isMetadataDrawerOpen && assignmentData && Object.keys(assignmentData).length > 0) {
      handleOpenMetadataDrawer();
    }
  }, [searchParams, assignmentData, isMetadataDrawerOpen]);

  const handleConfigFormChange = (e) => {
    const { name, value: val, type, checked } = e.target;
    setConfigForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : val }));
  };

  const handleSaveConfig = () => {
    if (!configValidator.allValid()) {
      showConfigValidator(true);
      return;
    }
    setIsSavingConfig(true);
    const body = {
      title: configForm.title,
      description: configForm.description,
      instructions: configForm.instructions,
      submission_date: configForm.submission_date,
      allow_late_submission: configForm.allow_late_submission,
      randomize_questions: configForm.randomize_questions,
      randomize_options: configForm.randomize_options,
      display_score_after_due_date: configForm.display_score_after_due_date,
      questions_display_mode: configForm.questions_display_mode
    };
    httprequest.patch(`${ASSIGNMENT_CONFIG_ENDPOINT}/${configData?.id}`, body)
      .then(() => {
        setIsSavingConfig(false);
        toast.success("Assignment config updated.");
        handleCloseMetadataDrawer();
        getAssignmentById();
      })
      .catch((err) => {
        setIsSavingConfig(false);
        toast.error(err?.response?.data?.message ?? "Failed to update config.");
      });
  };

  // ─── Normalise question for form ──────────────────────────────────────────

  const normalizeQuestion = (q) => ({
    question: q?.question ?? q?.question_text ?? "",
    type: q?.type ?? "",
    options: Array.isArray(q?.options) ? q.options.map((o) =>
      typeof o === "object" && o !== null && (o?.file_url || o?.text != null) ? o : (typeof o === "string" ? o : "")
    ) : [""],
    answer: Array.isArray(q?.answer) ? q.answer : (q?.answer != null ? [q.answer] : []),
    grade_point: q?.grade_point ?? 0,
    add_to_bank: q?.add_to_bank ?? false,
    id: q?.id ?? null,
    file: q?.file ?? {},
    required: q?.required ?? false,
    question_index: q?.question_index ?? 0
  });

  const blankQuestion = (index = 1) => ({
    question: "", type: "", options: [""], answer: [], grade_point: 0, add_to_bank: false, id: null, file: {}, required: false, question_index: index
  });

  // ─── True/False option seeding ────────────────────────────────────────────

  const seedTrueFalseOptions = (q) =>
    q.type === "true_false" ? { ...q, options: ["True", "False"] } : q;

  // ─── Generic question array helpers (factory) ─────────────────────────────

  const makeQueHandlers = (setter) => ({
    onQueChange: (e, index) => {
      const { name, value: val } = e.target;
      setter((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: val } : q)));
    },
    onQueTypeChange: (e, index) => {
      const { name, value: val } = e.target;
      setter((prev) => prev.map((q, i) => {
        if (i !== index) return q;
        const base = { ...q, [name]: val };
        if (val === "true_false") return { ...base, options: ["True", "False"], answer: [] };
        const options = q.options?.length > 0 ? q.options : [""];
        return { ...base, options };
      }));
    },
    onQuePointChange: (e, index) => {
      const { name, value: val } = e.target;
      setter((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: val } : q)));
    },
    onCorrectChoiceChange: (e, index, queInd) => {
      const { checked, type } = e.target;
      setter((prev) => {
        const next = [...prev];
        const q = next[queInd];
        if (!q) return prev;
        if (type === "radio") { next[queInd] = { ...q, answer: [index] }; return next; }
        const answers = q.answer || [];
        next[queInd] = { ...q, answer: checked ? (answers.includes(index) ? answers : [...answers, index]) : answers.filter((a) => a !== index) };
        return next;
      });
    },
    onMultipleChoiceChange: (e, optionIndex, questionIndex) => {
      const { value: val } = e.target;
      setter((prev) => {
        const next = [...prev];
        const q = next[questionIndex];
        if (!q?.options) return prev;
        const newOptions = [...q.options];
        newOptions[optionIndex] = typeof newOptions[optionIndex] === "object" && newOptions[optionIndex] !== null
          ? { ...newOptions[optionIndex], text: val }
          : val;
        next[questionIndex] = { ...q, options: newOptions };
        return next;
      });
    },
    onAdditionalOptions: (queInd) => {
      setter((prev) => {
        const next = [...prev];
        const q = next[queInd];
        const opts = q?.options?.length ? [...q.options, ""] : [""];
        next[queInd] = { ...q, options: opts };
        return next;
      });
    },
    onAdditionalQuestion: () => {
      setter((prev) => [...prev, blankQuestion((prev?.length ?? 0) + 1)]);
    },
    onRemoveQuestion: (index) => {
      setter((prev) => prev.filter((_, i) => i !== index));
    },
    onRemoveChoice: (optionIndex, queInd) => {
      setter((prev) => {
        const next = [...prev];
        const q = next[queInd];
        if (!q?.options?.length) return prev;
        const newOptions = q.options.filter((_, i) => i !== optionIndex);
        next[queInd] = { ...q, options: newOptions.length ? newOptions : [""] };
        return next;
      });
    },
    onQueDescChange: (e, index) => {
      const { name, value: val } = e.target;
      setter((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: val } : q)));
    },
    onRemoveDescription: (index) => {
      setter((prev) => prev.map((q, i) => {
        if (i !== index) return q;
        const rest = { ...q };
        delete rest.description;
        return rest;
      }));
    },
    onAddToBankChange: (e, index) => {
      const { checked } = e.target;
      setter((prev) => prev.map((q, i) => (i === index ? { ...q, add_to_bank: checked } : q)));
    },
    onQueImageChange: async (event, queInd) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response?.data?.data?.[0]?.upload_id,
              file_url: response?.data?.data?.[0]?.file_url
            };
            setter((prev) => prev.map((q, i) => (i === queInd ? { ...q, file: uploadedImageDetails } : q)));
            toast.success(`Image added to question ${queInd + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message || "Failed to upload image.");
        }
      }
    },
    onOptionImageChange: async (event, optionIndex, questionIndex) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response.data.data[0].upload_id,
              file_url: response.data.data[0].file_url
            };
            setter((prev) => {
              const next = [...prev];
              const q = next[questionIndex];
              if (!q?.options) return prev;
              const newOptions = [...q.options];
              newOptions[optionIndex] = uploadedImageDetails;
              next[questionIndex] = { ...q, options: newOptions };
              return next;
            });
            toast.success(`Image added to option ${optionIndex + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message || "Failed to upload image.");
        }
      }
    },
    onRemoveQueImage: async (queInd, upload_id) => {
      if (!upload_id) {
        toast.error("No upload ID found for this question"); return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setter((prev) => prev.map((q, i) => (i === queInd ? { ...q, file: {} } : q)));
          toast.success("Image removed successfully");
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message || "Failed to remove image");
      }
    },
    onRemoveOptionImage: async (optionIndex, queInd, upload_id) => {
      if (!upload_id) {
        toast.error("No upload ID found for this option"); return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setter((prev) => {
            const next = [...prev];
            const q = next[queInd];
            if (!q?.options) return prev;
            const newOptions = [...q.options];
            newOptions[optionIndex] = { upload_id: "", file_url: "" };
            next[queInd] = { ...q, options: newOptions };
            return next;
          });
          toast.success("Option image removed successfully");
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message || "Failed to remove image");
      }
    },
    onIconClick: (queInd, idPrefix) => {
      document.getElementById(`${idPrefix}-imageInput-${queInd}`)?.click();
    },
    onIconOptionClick: (i, queInd, idPrefix) => {
      document.getElementById(`${idPrefix}-imageInput-${i}${queInd}`)?.click();
    }
  });

  // ─── Add question modal ───────────────────────────────────────────────────

  const handleOpenAddQuestionModal = () => {
    setAddQuestionArr([blankQuestion(1)]);
    setIsAddQuestionModalOpen(true);
  };

  const addHandlers = makeQueHandlers(setAddQuestionArr);

  const addHandleClick = (event, queInd) => {
    setAddAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const addHandleMenuClose = () => setAddAnchorEl(null);
  const addToggleDescription = () => {
    setAddQuestionArr((prev) => {
      const next = [...prev];
      if (next[currentAnchor]) next[currentAnchor] = { ...next[currentAnchor], description: "" };
      return next;
    });
    addHandleMenuClose();
  };

  const buildQuestionsPayload = (arr) =>
    arr.map((q) => {
      const optionValues = (q.options || []).map((opt) =>
        typeof opt === "object" && opt !== null
          ? (opt?.text != null && opt.text !== "" ? opt.text : (opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : opt))
          : opt
      );
      const item = {
        type: q.type,
        question_text: (q.question || "").trim(),
        options: optionValues,
        answer: Array.isArray(q.answer) ? q.answer : [],
        grade_point: Number(q.grade_point) || 0,
        add_to_bank: !!q.add_to_bank
      };
      if (q.id) item.id = q.id;
      return item;
    });

  /** PATCH /api/v1/assignment-configs/:id/questions — `{ questions }` only (full sync) */
  const patchAssignmentQuestions = (questionsArr) =>
    httprequest.patch(`${ASSIGNMENT_CONFIG_ENDPOINT}/${configData?.id}/questions`, {
      questions: buildQuestionsPayload(questionsArr)
    });

  /** POST /api/v1/assignment-configs/:id/save — publish / withdraw / status transitions */
  const postAssignmentQuestionsSave = (status, questionsArr) =>
    httprequest.post(`${ASSIGNMENT_CONFIG_ENDPOINT}/${configData?.id}/save`, {
      questions: buildQuestionsPayload(questionsArr),
      status
    });

  const handleSaveAddQuestions = () => {
    if (!addQuestionsValidator.allValid()) { showAddQuestionsValidator(true); return; }
    setIsAddingQuestions(true);
    postAssignmentQuestionsSave("published", addQuestionArr)
      .then(() => {
        setIsAddingQuestions(false);
        toast.success("Assignment published successfully.");
        setIsAddQuestionModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsAddingQuestions(false);
        toast.error(err?.response?.data?.message ?? "Failed to publish assignment.");
      });
  };

  const handleSaveAddQuestionsDraft = () => {
    setIsAddingDraft(true);
    patchAssignmentQuestions(addQuestionArr)
      .then(() => {
        setIsAddingDraft(false);
        toast.success("Saved as draft.");
        setIsAddQuestionModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsAddingDraft(false);
        toast.error(err?.response?.data?.message ?? "Failed to save draft.");
      });
  };

  const handleWithdrawAssignment = () => {
    setIsAddingQuestions(true);
    postAssignmentQuestionsSave("withdrawn", addQuestionArr)
      .then(() => {
        setIsAddingQuestions(false);
        toast.success("Assignment withdrawn successfully.");
        setIsAddQuestionModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsAddingQuestions(false);
        toast.error(err?.response?.data?.message ?? "Failed to withdraw assignment.");
      });
  };

  // ─── Edit question modal ──────────────────────────────────────────────────

  const handleOpenEditQuestionsModal = () => {
    const source = assignmentData?.questions ?? [];
    const normalized = source.length > 0
      ? source.map(normalizeQuestion).map(seedTrueFalseOptions)
      : [blankQuestion(1)];
    setEditQuestionArr(normalized);
    setIsEditQuestionsModalOpen(true);
  };

  const editHandlers = makeQueHandlers(setEditQuestionArr);

  const editHandleClick = (event, queInd) => {
    setEditAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const editHandleMenuClose = () => setEditAnchorEl(null);
  const editToggleDescription = () => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      if (next[currentAnchor]) next[currentAnchor] = { ...next[currentAnchor], description: "" };
      return next;
    });
    editHandleMenuClose();
  };

  const handleUpdateQuestions = () => {
    if (!editQuestionsValidator.allValid()) { showEditQuestionsValidator(true); return; }
    setIsUpdatingQuestions(true);
    patchAssignmentQuestions(editQuestionArr)
      .then(() => {
        setIsUpdatingQuestions(false);
        toast.success("Questions updated successfully.");
        setIsEditQuestionsModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsUpdatingQuestions(false);
        toast.error(err?.response?.data?.message ?? "Failed to update questions.");
      });
  };

  const handleEditPublishQuestions = () => {
    if (!editQuestionsValidator.allValid()) { showEditQuestionsValidator(true); return; }
    setIsPublishingEditQuestions(true);
    postAssignmentQuestionsSave("published", editQuestionArr)
      .then(() => {
        setIsPublishingEditQuestions(false);
        toast.success("Assignment published successfully.");
        setIsEditQuestionsModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsPublishingEditQuestions(false);
        toast.error(err?.response?.data?.message ?? "Failed to publish assignment.");
      });
  };

  const handleEditWithdrawQuestions = () => {
    if (!editQuestionsValidator.allValid()) { showEditQuestionsValidator(true); return; }
    setIsWithdrawingEditQuestions(true);
    postAssignmentQuestionsSave("withdrawn", editQuestionArr)
      .then(() => {
        setIsWithdrawingEditQuestions(false);
        toast.success("Assignment withdrawn successfully.");
        setIsEditQuestionsModalOpen(false);
        getAssignmentById();
      })
      .catch((err) => {
        setIsWithdrawingEditQuestions(false);
        toast.error(err?.response?.data?.message ?? "Failed to withdraw assignment.");
      });
  };

  // ─── Export ───────────────────────────────────────────────────────────────

  const handleExportModalToggle = () => setIsExportModalOpen(!isExportModalOpen);

  const exportToWord = () => {
    if (!assignmentData || !assignmentData.questions) {
      toast.error("No assignment data available.");
      return;
    }

    let htmlContent = `
      <h1>${assignmentData.title || "Assignment"}</h1>
      <p><strong>Created By:</strong> ${assignmentData?.created_by?.last_name || ""} ${assignmentData?.created_by?.first_name || ""}</p>
      <p><strong>Subject:</strong> ${assignmentData?.subject?.name || "--/--"}</p>
      <p><strong>Class:</strong> ${assignmentData?.class?.name || "--/--"}</p>
      <p><strong>Instructions:</strong> ${assignmentData?.instructions || "--/--"}</p>
      <hr />
      <h2>Questions:</h2>
    `;

    assignmentData.questions.forEach((question, idx) => {
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <h3>Q${questionDisplayIndex(question, idx, assignmentData.questions)}: ${question.question ?? question.question_text}</h3>
          ${question?.file?.file_url ? `<img src="${question.file.file_url}" width="200"/>` : ""}
          <ul>
            ${(question.options || []).map((option) => {
    const content = typeof option === "object" && option?.file_url
      ? `<img src="${option.file_url}" width="150"/>`
      : option;
    return `<li>${content}</li>`;
  }).join("")}
          </ul>
        </div>
      `;
    });

    const blob = HTMLDocx.asBlob(htmlContent);
    saveAs(blob, `${assignmentData?.subject?.name || "assignment"} - ${assignmentData.title || "assignment"}.docx`);
    toast.success("Assignment exported successfully.");
    setIsExportModalOpen(false);
  };

  // ─── Table columns ────────────────────────────────────────────────────────

  const resultColumns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {`${row?.student?.first_name || ""} ${row?.student?.last_name || ""}`.trim() || "--/--"}
        </>
      )
    },
    {
      name: "Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Score</p>}
          {`${row?.total_grade ?? "--"} / ${row?.attainable_score ?? "--"}`}
        </>
      )
    },
    {
      name: "View",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.submission_id} className="table-action-container">
          <Link to={`/assignment-result-details/${row?.submission_id || row?.id}`} className="table-action-icon">
            <Icon icon="ph:arrow-right-bold" width="20" height="20" />
          </Link>
        </div>
      )
    }
  ];

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            {isTeacher ? (
              <BreadCrumb
                link_one="/my-assignments"
                link_one_name="Assignments"
                active={`${assignmentData?.subject?.name || ""} Assignment`}
                description="See the details of this assignment"
              />
            ) : (
              <BreadCrumb
                link_one="/assignments"
                link_one_name="Assignments"
                active={`${assignmentData?.subject?.name || ""} Assignment`}
                description="See the details of this assignment"
              />
            )}
          </div>

          <div className="page-content">
            <PageTitle
              className={classes.inline}
              title={`${assignmentData?.title || ""}`}
              subtitle={`Created By: ${assignmentData?.created_by?.last_name || "--/--"} ${assignmentData?.created_by?.first_name || "--/--"} || Class: ${assignmentData?.class?.name || "--/--"}`}
              button={
                <div className={classes.actionIconGroup}>
                  {value === "1" && (
                    <Tooltip title="Export to Word" arrow placement="top">
                      <button
                        type="button"
                        className={classes.exportIconBtn}
                        onClick={handleExportModalToggle}
                        aria-label="Export to Word"
                      >
                        <Icon icon="flowbite:file-export-outline" width="22" height="22" />
                      </button>
                    </Tooltip>
                  )}
                  <Tooltip title="Edit Assignment Config" arrow placement="top">
                    <button
                      type="button"
                      className={classes.exportIconBtn}
                      onClick={() => navigate({ pathname: location.pathname, search: buildSearchWithEditConfig() })}
                      aria-label="Edit Assignment Config"
                    >
                      <Icon icon="fluent:edit-16-regular" width="22" height="22" />
                    </button>
                  </Tooltip>
                  {canGenerateQuestions && (
                    <Tooltip title="Generate Questions" arrow placement="top">
                      <button
                        type="button"
                        className={classes.editIconBtn}
                        onClick={() => setIsGenerateDrawerOpen(true)}
                        aria-label="Generate Questions"
                      >
                        <Icon icon="fluent-color:bot-sparkle-16" width="22" height="22" />
                      </button>
                    </Tooltip>
                  )}
                </div>
              }
            />

            <TabContext value={value}>
              <div className="tablist-container padding-left-16">
                <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
                  <Tab label="Assignment Details" value="1" />
                  <Tab label="Student Results" value="2" />
                </Tabs>
              </div>

              {/* ── Details Tab ─────────────────────────────────────────── */}
              <TabPanel value="1" className="tabpanel-overide">
                <Grid container sx={{ marginLeft: "0px !important", marginTop: "14px" }} spacing={1}>
                  <div className="key-pair-container">
                    <Grid container spacing={1}>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Subject Name" subtitle={assignmentData?.subject?.name || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Term" subtitle={assignmentData?.term?.term || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Class" subtitle={assignmentData?.class?.name || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Created By" subtitle={`${assignmentData?.created_by?.last_name || "--/--"} ${assignmentData?.created_by?.first_name || "--/--"}`} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Created At" subtitle={assignmentData?.created_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Title" subtitle={assignmentData?.title || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Submission Date" subtitle={assignmentData?.submission_date?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Total Grade" subtitle={assignmentData?.total_grade ?? "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Updated At" subtitle={assignmentData?.updated_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText
                          title="Status"
                          subtitle={
                            <div className="subtitle-container">
                              <Badge status={assignmentData?.status} />
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Allow Late Submission" subtitle={assignmentData?.allow_late_submission ? "Yes" : "No"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Visibility" subtitle={assignmentData?.is_private ? "Private" : "Public"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Display Mode" subtitle={assignmentData?.questions_display_mode?.replace(/_/g, " ") || "--/--"} />
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <AssignmentDetailText title="Instructions" subtitle={assignmentData?.instructions || "--/--"} />
                      </Grid>
                      {assignmentData?.description && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <AssignmentDetailText title="Description" subtitle={assignmentData?.description} />
                        </Grid>
                      )}
                    </Grid>
                  </div>

                  {/* ── Questions section ──────────────────────────────── */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {hasQuestions && (
                      <div style={{ marginBottom: 10 }}>
                        <WidgetTitle
                          title="Questions"
                          link={
                            !isPublishedAssignment ? (
                              <Button
                                variant="primaryoutline"
                                color="btnfontprimary"
                                buttonSize="fluid"
                                onClick={handleOpenEditQuestionsModal}
                                buttonName="Edit Questions"
                                disabled={assignmentStatus === "expired"}
                              />
                            ) : null
                          }
                        />
                      </div>
                    )}

                    {!hasQuestions ? (
                      <div style={{ minHeight: 280, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
                        <NotFounditem
                          img={noexam}
                          title="No questions have been added"
                          subtitle="Add questions for this assignment"
                        >
                          {!isPublishedAssignment && (
                            <Button
                              variant="primary"
                              color="btndefault"
                              buttonSize="fluid"
                              onClick={handleOpenAddQuestionModal}
                              buttonName="Add Question"
                            />
                          )}
                        </NotFounditem>
                      </div>
                    ) : (
                      <Grid container spacing={2}>
                        {assignmentData?.questions?.map((item, i) => {
                          const hasImageOption = item?.options?.some(
                            (option) => typeof option === "object" && option.file_url
                          );

                          return (
                            <Grid item lg={4} md={6} sm={12} xs={12} key={i}>
                              <div className="question-preview-container">
                                <h3 className="question-preview-heading">
                                  Question {questionDisplayIndex(item, i, assignmentData?.questions)}
                                </h3>
                                <div className={classes.question}>
                                  <h3 className="question-preview-heading">
                                    {item?.question ?? item?.question_text}{item?.required ? <span className="input-required">*</span> : null}
                                    {item?.file?.file_url ? (
                                      <div className={classes.quesdisplay}>
                                        <img src={item?.file?.file_url} alt="" />
                                      </div>
                                    ) : <div className={classes.displaynone}></div>}
                                  </h3>

                                  {(item?.type === "multiple_choice" || item?.type === "true_false") ? (
                                    hasImageOption ? (
                                      <Grid container spacing={2}>
                                        {item?.options?.map((option, optIdx) => {
                                          const isImageOption = typeof option === "object" && option.file_url;
                                          return (
                                            <Grid item lg={6} md={6} sm={12} xs={12} key={optIdx}>
                                              <div className="options-preview">
                                                <input type="radio" checked={item?.answer?.includes(optIdx)} name={`q_${i}`} disabled readOnly />
                                                {isImageOption ? (
                                                  <div className={classes.optiondisplay}>
                                                    <img src={option.file_url} alt={`Option ${optIdx + 1}`} />
                                                  </div>
                                                ) : <label>{option}</label>}
                                              </div>
                                            </Grid>
                                          );
                                        })}
                                      </Grid>
                                    ) : (
                                      <>
                                        {item?.options?.map((option, optIdx) => (
                                          <div key={optIdx} className="options-preview">
                                            <input type="radio" checked={item?.answer?.includes(optIdx)} name={`q_${i}`} disabled readOnly />
                                            <label>{option}</label>
                                          </div>
                                        ))}
                                      </>
                                    )
                                  ) : item?.type === "checkbox" ? (
                                    hasImageOption ? (
                                      <Grid container spacing={2}>
                                        {item?.options?.map((option, optIdx) => {
                                          const isImageOption = typeof option === "object" && option.file_url;
                                          return (
                                            <Grid item lg={6} md={6} sm={12} xs={12} key={optIdx}>
                                              <div className="options-preview">
                                                <input type="checkbox" checked={item?.answer?.includes(optIdx)} name={`q_${i}`} disabled readOnly />
                                                {isImageOption ? (
                                                  <div className={classes.optiondisplay}>
                                                    <img src={option.file_url} alt={`Option ${optIdx + 1}`} />
                                                  </div>
                                                ) : <label>{option}</label>}
                                              </div>
                                            </Grid>
                                          );
                                        })}
                                      </Grid>
                                    ) : (
                                      <>
                                        {item?.options?.map((option, optIdx) => (
                                          <div key={optIdx} className="options-preview">
                                            <input type="checkbox" checked={item?.answer?.includes(optIdx)} name={`q_${i}`} disabled readOnly />
                                            <label>{option}</label>
                                          </div>
                                        ))}
                                      </>
                                    )
                                  ) : null}
                                </div>
                              </div>
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </TabPanel>

              {/* ── Student Results Tab ──────────────────────────────────── */}
              <TabPanel sx={{ padding: "0px !important" }} value="2">
                {isFetchingResults ? (
                  <div className="flex justify-content-center" style={{ padding: "60px 0" }}>
                    <Icon icon="svg-spinners:270-ring-with-bg" width="40" height="40" style={{ color: "#858585" }} />
                  </div>
                ) : (
                  <Table
                    data={attendeeFilter}
                    columns={resultColumns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      attendeeFilter?.length > 0 && (
                        <div className="action_div">
                          <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAttendees} />
                        </div>
                      )
                    }
                  />
                )}
              </TabPanel>
            </TabContext>
          </div>

          {/* ── Export Modal ──────────────────────────────────────────────── */}
          <Modal
            title="Export to Word"
            subtitle="Are you sure you want to export this assignment to Word?"
            modalContent={<p>This will generate a Word document of the assignment.</p>}
            modalFooter={
              <div className="flex gap-10">
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Confirm Export" onClick={exportToWord} />
              </div>
            }
            isopen={isExportModalOpen}
            closeModal={handleExportModalToggle}
          />

          {/* ── Add Questions Modal (full screen) ────────────────────────── */}
          <Modal
            fullScreen
            title="Add Questions"
            subtitle={isPublishedAssignment ? "This assignment is published. You can withdraw it." : "Add questions for this assignment, then save as draft or publish."}
            isopen={isAddQuestionModalOpen}
            closeModal={() => setIsAddQuestionModalOpen(false)}
            modalContent={
              <AssignmentQuestionsModalContent
                questionArr={addQuestionArr}
                classes={classes}
                questionsValidator={addQuestionsValidator}
                isSubmitting={isAddingQuestions}
                isDraftSubmitting={isAddingDraft}
                idPrefix="add"
                {...addHandlers}
                onMenuClick={addHandleClick}
                onMenuClose={addHandleMenuClose}
                onToggleDescription={addToggleDescription}
                anchorEl={addAnchorEl}
                menuOpen={addMenuOpen}
                showDraftAndCreateButtons={!isPublishedAssignment}
                hideAddQuestionAction={isPublishedAssignment}
                onSave={isPublishedAssignment ? handleWithdrawAssignment : handleSaveAddQuestions}
                onSaveDraft={isPublishedAssignment ? null : handleSaveAddQuestionsDraft}
                saveButtonLabel={isPublishedAssignment ? "Withdraw" : "Publish"}
              />
            }
            modalFooter={null}
          />

          {/* ── Edit Questions Modal (full screen) ───────────────────────── */}
          <Modal
            fullScreen
            title="Edit Questions"
            subtitle={
              editQuestionsFooterMode === "published"
                ? "This assignment is published. You can withdraw it or review questions."
                : "Update assignment questions. You can add more or remove questions."
            }
            isopen={isEditQuestionsModalOpen}
            closeModal={() => setIsEditQuestionsModalOpen(false)}
            modalContent={
              <AssignmentQuestionsModalContent
                questionArr={editQuestionArr}
                classes={classes}
                questionsValidator={editQuestionsValidator}
                isSubmitting={isUpdatingQuestions}
                idPrefix="edit"
                {...editHandlers}
                onMenuClick={editHandleClick}
                onMenuClose={editHandleMenuClose}
                onToggleDescription={editToggleDescription}
                anchorEl={editAnchorEl}
                menuOpen={editMenuOpen}
                showDraftAndCreateButtons={false}
                hideAddQuestionAction={editQuestionsFooterMode === "published"}
                editFooterMode={editQuestionsFooterMode}
                onEditUpdate={handleUpdateQuestions}
                onEditPublish={handleEditPublishQuestions}
                onEditWithdraw={handleEditWithdrawQuestions}
                isEditUpdating={isUpdatingQuestions}
                isEditPublishing={isPublishingEditQuestions}
                isEditWithdrawing={isWithdrawingEditQuestions}
              />
            }
            modalFooter={null}
          />

          {/* ── Edit Assignment Config Drawer ─────────────────────────────── */}
          <RightDrawer
            open={isMetadataDrawerOpen}
            onClose={handleCloseMetadataDrawer}
            title="Edit Assignment Config"
            width={520}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  inputName="title"
                  margin="normal"
                  inputType="text"
                  placeHolder="Enter title"
                  value={configForm.title}
                  onChange={handleConfigFormChange}
                  required
                />
                {configValidator.message("title", configForm.title?.trim(), "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Description"
                  inputName="description"
                  margin="normal"
                  placeholder="Enter description"
                  value={configForm.description}
                  onChange={handleConfigFormChange}
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Instructions"
                  inputName="instructions"
                  margin="normal"
                  placeholder="Enter instructions"
                  value={configForm.instructions}
                  onChange={handleConfigFormChange}
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Submission Date"
                  inputName="submission_date"
                  margin="normal"
                  inputType="date"
                  value={configForm.submission_date}
                  onChange={handleConfigFormChange}
                  required
                />
                {configValidator.message("submission_date", configForm.submission_date, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Questions Display Mode"
                  required
                  children={
                    <select name="questions_display_mode" value={configForm.questions_display_mode} onChange={handleConfigFormChange}>
                      <option value="all_at_once">All at Once</option>
                      <option value="one_per_page">One Per Page</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex align-items-center gap-10">
                  <input
                    type="checkbox"
                    id="allow_late_submission"
                    name="allow_late_submission"
                    checked={!!configForm.allow_late_submission}
                    onChange={handleConfigFormChange}
                  />
                  <label htmlFor="allow_late_submission">Allow Late Submission</label>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex align-items-center gap-10">
                  <input
                    type="checkbox"
                    id="randomize_questions"
                    name="randomize_questions"
                    checked={!!configForm.randomize_questions}
                    onChange={handleConfigFormChange}
                  />
                  <label htmlFor="randomize_questions">Randomize Questions</label>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex align-items-center gap-10">
                  <input
                    type="checkbox"
                    id="randomize_options"
                    name="randomize_options"
                    checked={!!configForm.randomize_options}
                    onChange={handleConfigFormChange}
                  />
                  <label htmlFor="randomize_options">Randomize Options</label>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex align-items-center gap-10">
                  <input
                    type="checkbox"
                    id="display_score_after_due_date"
                    name="display_score_after_due_date"
                    checked={!!configForm.display_score_after_due_date}
                    onChange={handleConfigFormChange}
                  />
                  <label htmlFor="display_score_after_due_date">Display Score After Due Date</label>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Save Config"
                  isLoading={isSavingConfig}
                  onClick={handleSaveConfig}
                />
              </Grid>
            </Grid>
          </RightDrawer>

          <GenerateQuestionsDrawer
            open={isGenerateDrawerOpen}
            onClose={() => setIsGenerateDrawerOpen(false)}
            isAdmin={isAdmin}
            lessonOutlineId={location.state?.lessonOutline?.lesson_outline_id}
            versionId={location.state?.lessonOutline?.version_id}
            initialDestinationType="assignment"
            initialDestinationId={assignmentData?.id ?? id}
            examContext={{
              title: assignmentData?.title,
              subjectName: assignmentData?.subject?.name,
              subjectId: assignmentData?.subject?.id ?? assignmentData?.subject_id,
              classLabel: assignmentData?.class?.name,
              description: assignmentData?.description || ""
            }}
          />

          {/* ── Submission Viewer Modal Removed ───────────────────────── */}
        </>
      }
    />
  );
};

export default AssignmentDetail;
